export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    title: '检验详情',
    field: 'v_inspectionDetail',
    align: 'left',
    slots: {
      default: 'showItem'
    }
  }
]
